import { z } from "zod";

const BrandOrganizationSchema = z.object({
    "@id": z.string(),
    name: z.string(),
});

const BrandBaseSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
    organization: BrandOrganizationSchema,
    logoUrl: z.string().nullable().optional(),
    sharedWithAllSubsidiaries: z.boolean(),
});

export const BrandSchema = BrandBaseSchema.extend({
    sharedWithOrganizations: BrandOrganizationSchema.array(),
});

export const BrandListSchema = BrandBaseSchema.extend({
    canView: z.boolean(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});

export type BrandOrganization = z.output<typeof BrandOrganizationSchema>;
export type Brand = z.output<typeof BrandSchema>;
export type BrandList = z.output<typeof BrandListSchema>;
